<script setup lang="ts">
import { info } from '@/components/icons/icons';
import Tooltip from '@/components/Tooltip/Tooltip.vue';

export interface InfoMessageProps {
  value?: string;
  icon?: string;
  size?: string | number;
  disabled?: boolean;
  color?: string;
}
withDefaults(defineProps<InfoMessageProps>(), {
  value: undefined,
  icon: info,
  size: 20,
  color: 'primary',
});
const slots = defineSlots<{
  default?(props: unknown): any;
}>();
</script>

<template>
  <Tooltip v-if="slots['default'] || value" :disabled="disabled">
    <template #target="{ props }">
      <v-icon
        :color="disabled ? 'primary-lighten-3' : color"
        :icon="icon"
        :size="size"
        v-bind="{ ...props, ...$attrs }"
      />
    </template>
    <template #tooltip>
      <slot>
        {{ value }}
      </slot>
    </template>
  </Tooltip>
</template>

<style scoped lang="scss">
.v-icon {
  vertical-align: text-top;
  margin-left: 2px;
}
</style>
